/**
 * Lookup helpers for assets bundled at build time.
 *
 * Application code should prefer these helpers so worlds and code files never
 * hit the network. Every world/code file is inlined into the bundle at build
 * time (see `src/assets/`), so the lookups are synchronous and a miss is a bug.
 */
import { karelCodeTextByName, normalizeCodeName } from "../assets/karelCode";
import { normalizeWorldName, worldTextByName } from "../assets/worlds";

/** Returns bundled world text for a name, accepting `u5l1`, `worlds/u5l1.w`, or `apcsp/c1l1`. */
export function getWorldText(name: string): string | undefined {
  return worldTextByName[normalizeWorldName(name)];
}

/** Returns bundled code text for a path, accepting `karelCode/u5l1.starter.js` or `karelCode/apcsp/c1l1.starter.js`. */
export function getKarelCodeText(path: string): string | undefined {
  return karelCodeTextByName[normalizeCodeName(path)];
}

/** Resolves world text from the bundle, throwing when the world is missing. */
export function requireWorldText(name: string): string {
  const bundled = getWorldText(name);
  if (bundled === undefined) {
    throw new Error(`World not found in bundle: ${name}`);
  }
  return bundled;
}

/** Resolves code text from the bundle, throwing when the code is missing. */
export function requireKarelCodeText(path: string): string {
  const bundled = getKarelCodeText(path);
  if (bundled === undefined) {
    throw new Error(`Code not found in bundle: ${path}`);
  }
  return bundled;
}
